import { fetchAgg } from '../../../../common/utils/fetch-agg';
import { operationName, quickFindRecentActivitiesQuery } from './query';
export var recentActivitiesQuery = function recentActivitiesQuery(_ref) {
  var variables = _ref.variables,
    aggAbsoluteUrl = _ref.aggAbsoluteUrl;
  return fetchAgg({
    variables: variables,
    aggAbsoluteUrl: aggAbsoluteUrl,
    graphQuery: quickFindRecentActivitiesQuery,
    operationName: operationName
  });
};